<template>
    <div>
        <div v-if="zero_search_results || projects.length > 0 || data_loading" class="w-full">
            <div class="flex flex-wrap flex-lg-nowrap lg:justify-between mt-4">

                <div class="w-full md:w-2/3 flex">
                    <div class="bg-grey-lighter rounded-full w-full xl:w-1/3 items-center">
                        <input
                            ref="filter"
                            type="search"
                            dusk="search-by-name"
                            class="bg-grey-lighter text-grey-darkest w-5/6 focus:outline-none p-2 rounded-full ml-3 text-sm"
                            placeholder="Search by name..."
                            v-model="filter.project_name"
                            @input="debounceFilter"
                        />

                        <div class="flex-1 text-right pr-3">
                            <i v-if="data_loading" class="fa fa-spin fa-spinner text-grey-darkest"
                               aria-hidden="true"></i>
                        </div>
                    </div>

                    <save-pattern ref="savePatternModal"></save-pattern>
                    <use-pattern ref="usePatternModal"
                                 v-on:use-pattern="(filter) => fetchProjects(filter)"></use-pattern>

                </div>
            </div>
            <div v-if="zero_search_results">
                <div class="mt-32 text-center text-grey-darkest text-lg">No results found. Consider changing your search
                    or creating a new project.
                </div>
            </div>
            <div v-if="!zero_search_results" class="bg-white shadow-md rounded mb-6 mt-4 overflow-auto"
                 :style="inline_update_loading || pin_project_loading ? 'opacity:0.3' : ''">

                <div v-if="checked_project_ids.length > 0" class="w-full d-flex flex-wrap p-2 text-grey-darkest border-b border-grey-light">
                    {{checked_project_ids.length}} project(s) selected
                </div>
                <div v-if="checked_project_ids.length > 0" class="w-full d-flex flex-wrap mt-1 mb-1 bg-grey-lightest text-xs text-grey-darkest border-b border-grey-light">

                    <b-form-checkbox
                        id="checkbox-1"
                        class="check_current_checkbox2"
                        v-model="check_current"
                        name="checkbox-1"
                        @change="checkCurrent"
                    >
                    </b-form-checkbox>

                    <b-form-checkbox
                        id="checkbox-2"
                        style="padding-top: 1px"
                        class="text-sm"
                        v-model="check_all"
                        name="checkbox-1"
                        @change="checkAll"
                    >Select All
                    </b-form-checkbox>
<!--                    <th class="py-1 px-3 bg-grey-lightest font-bold uppercase text-xs text-grey-darkest border-b border-grey-light text-center" style="width:3%">-->
<!--                        <input type="checkbox" class="bg-teal" name="checkAllProject" v-model="check_all">Select All-->
<!--                    </th>-->
<!--                    <input type="checkbox" class="mt-1 ml-3 py-3 px-3" v-model="uncheck_all" @click="clearChecked">-->
<!--                    <label>Select All</label>-->

                    <button type="button" class="bulk-update-button pl-3 py-1 px-3" @click="updateAssignedUsersModal">
                        Assign
                    </button>

                    <assigned-users ref="updateAssignedUsersModal" :checked_project_ids="checked_project_ids"
                                    v-on:update-finished="massUpdateFinished" :field-labels="fieldLabels"></assigned-users>

                    <button type="button" class="bulk-update-button pl-3 py-1 px-3" @click="updateFieldUpdateModal">
                        Update Field
                    </button>

                    <update-field ref="updateFieldUpdateModal" :checked_project_ids="checked_project_ids" :masks="masks"
                                  v-on:update-finished="massUpdateFinished" :field-labels="fieldLabels"></update-field>

                    <button type="button" class="bulk-update-button pl-3 py-1 px-3" @click="updateAddActivityModal">Add
                        an activity
                    </button>

                    <add-activity ref="updateAddActivityModal" :checked_project_ids="checked_project_ids"
                                  :calendar="calendar" :masks="masks"
                                  v-on:update-finished="massUpdateFinished"></add-activity>

                    <button type="button" class="bulk-update-button pl-3 py-1 px-3" @click="updateAddCompanyModal">Add
                        Company
                    </button>

                    <add-company ref="updateAddCompanyModal" :checked_project_ids="checked_project_ids"
                                 :calendar="calendar" :masks="masks" :symbols="this.symbols" :exchange="this.exchange"
                                 v-on:update-finished="massUpdateFinished"></add-company>

                    <button v-if="canDelete" type="button" class="bulk-update-button pl-3 py-1 px-3"
                            @click="massProjectDestroy">Delete
                    </button>

                    <span v-if="hasBulkEmailAccess">
                        <button type="button" class="bulk-update-button pl-3 py-1 px-3" @click="sendBulkEmail">Bulk Email</button>

                        <bulk-email ref="sendBulkEmail" :checked_project_ids="checked_project_ids" :checked_contact_ids="[]"></bulk-email>
                    </span>

                </div>

                <table class="text-left w-full border-collapse table-bordered" id="project_index">
                    <thead v-if="checked_project_ids.length == 0">
                    <tr>
<!--                        <th class="py-1 px-3 bg-grey-lightest font-bold uppercase text-xs text-grey-darkest border-b border-grey-light text-center" style="width:3%">-->
<!--                            <input type="checkbox" class="bg-teal" name="checkCurrentProject" v-model="check_current">-->
<!--                        </th>-->

                        <!-- <th class="py-1 bg-grey-lightest font-bold uppercase text-xs text-grey-darkest border-b border-grey-light text-center" style="width:3%">
                            <b-form-checkbox
                                id="checkbox-1"
                                class="check_current_checkbox"
                                v-model="check_current"
                                name="checkbox-1"
                                @change="checkCurrent"
                            >
                            </b-form-checkbox>
                        </th> -->

                        <th v-for="(column,index) in columnsToShow"
                            class="py-1 px-1 bg-grey-lightest font-bold uppercase text-xs text-grey-darkest border-b border-grey-light whitespace-no-wrap md:table-cell column-header-resize"
                            style="width:9%">
                            <div class="column-resize" :class="`${column.property_name}`">
                                <button v-if="availableSortingColumns[column.property_name]"
                                        class="font-bold uppercase text-xs text-grey-darkest hover:text-teal hover:no-underline focus:outline-none"
                                        :class="currentOrder.sortBy === column.property_name ? 'text-teal' : ''"
                                        @click="sortByColumn(column.property_name)">
                                    {{ getFieldLabel(fieldLabels, column.name.replace(/ /g, '-').toLowerCase()) }}
                                    <i class="fa fa-xs ml-2" :class="{'fa-chevron-up' : currentOrder.direction === 'asc',
                                        'fa-chevron-down' : currentOrder.direction === 'desc'}"
                                       v-if="currentOrder.sortBy === column.property_name"></i>
                                </button>
                                <button v-else
                                        class="font-bold uppercase text-xs text-grey-darkest hover:text-teal hover:no-underline focus:outline-none">
                                    {{ column.name }}
                                </button>
                            </div>
                        </th>
                        <th class="py-1 px-3 bg-grey-lightest font-bold uppercase text-xs text-grey-darkest border-b border-grey-light hidden xl:table-cell md:table-cell column-header-resize"
                            style="width:9%">
                            <div class="column-resize">
                                <button
                                    class="font-bold uppercase text-xs text-grey-darkest hover:text-teal hover:no-underline focus:outline-none"
                                    :class="currentOrder.sortBy === 'last_update' ? 'text-teal' : ''"
                                    @click="sortByColumn('last_update')">
                                    Last Update
                                    <i class="fa fa-xs ml-2"
                                       :class="{'fa-chevron-up' : currentOrder.direction === 'asc',
                                        'fa-chevron-down' : currentOrder.direction === 'desc'}"
                                       v-if="currentOrder.sortBy === 'last_update'"></i>
                                </button>
                            </div>
                        </th>
                        <!-- <th class="bg-grey-lightest border-b border-grey-light hidden xl:table-cell md:table-cell"
                            style="width:3%">
                            <div class="d-flex justify-content-center">
                                <i class="fa fa-fw text-left fa-btn fa-external-link pointer export-btn mr-3"
                                   title="Export" v-on:click="exportToExcel"></i>
                                <project-export-icon
                                    name="Projects"
                                    :projects="projects"
                                    :state="columns"
                                    :filter="current_search_pattern"
                                    :field-labels="fieldLabels"
                                    :is-view-state="isViewState"
                                    :view="view"
                                    v-on:stateUpdated="updateColumnState"
                                />
                            </div>
                        </th> -->
                    </tr>
                    </thead>
                    <tbody>
                    <tr v-if="data_loading">
                        <td colspan="11" class="text-5xl text-grey-darkest text-center mt-32">
                            <i class="fa fa-spin fa-spinner" aria-hidden="true"></i>
                        </td>
                    </tr>

                    <tr v-else class="hover:bg-white cursor-pointer"
                    v-for="(project, idx) in projects" :key="idx"
                    :class="project.id == requiredFieldProjectId ? 'required-field-missing' : ''">
                    <!-- <td @click.stop="() => null"
                        class="px-3 py-2 py-lg-0 border-b border-grey-light text-xs cursor-default"
                        :class="(project['pin_project'] === 1) ? 'pin-project-highlighted' : ''">
                        <input type="checkbox" class="bg-teal" v-model="checked_project_ids"
                               :id="'projectCheckbox' + project.id" :name="'projectCheckbox' + project.id"
                               :value="project.id" @change="checkProject">
                    </td> -->
                    <td v-for="column in columnsToShow"
                        class="pl-2 border-b border-grey-light text-xs md:table-cell"
                        :class="[(column.property_name == 'sequential_team_id' || column.property_name == 'name' || column.property_name == 'contact_name' || column.property_name == 'due_date' || column.property_name == 'address' || column.property_name == 'city' || column.property_name == 'state' || column.property_name == 'zip' || column.property_name == 'contact_email' || column.property_name == 'contact_phone' || column.property_name == 'contact_cell' || column.property_name == 'contact_fax' || column.property_name == 'company_contact_name' || column.property_name == 'company_contact_company_name' || column.property_name == 'company_contact_title' || column.property_name == 'company_contact_email' || column.property_name == 'company_contact_cell' || column.property_name == 'company_contact_followup' || column.property_name == 'company_contact_status') ? 'td-text-overflow' : '', (project['pin_project'] === 1) ? 'pin-project-highlighted' : '']">
                        <a v-show="column.property_name == 'contact_email'"
                           :href="`mailto:${project['contact_email'] ? project['contact_email'] : ''}`"
                           class="text-teal hover:text-teal-dark"
                           :class="(column.property_name != 'sequential_team_id') ? 'text-break' : ''">
                            {{ project['contact_email'] }}
                        </a>
                        <a v-show="column.property_name == 'contact_phone'"
                           :href="`tel:${project['contact_phone']}`" class="text-teal hover:text-teal-dark"
                           :class="(column.property_name != 'sequential_team_id') ? 'text-break' : ''">
                            <formatted-phone
                                v-if="project['contact_phone']" :phone="project['contact_phone']" :masks="masks"/>
                        </a>
                        <a v-show="column.property_name == 'contact_cell'"
                           style="text-decoration: none; color: #49545a;"
                           :class="(column.property_name != 'sequential_team_id') ? 'text-break' : ''">
                            <formatted-phone
                                v-if="project['contact_cell']" :phone="project['contact_cell']" :masks="masks"/>
                        </a>
                        <a v-show="column.property_name == 'company_contact_cell'"
                           style="text-decoration: none; color: #49545a;"
                           :class="(column.property_name != 'sequential_team_id') ? 'text-break' : ''">
                            <formatted-phone
                                v-if="project['company_contact_cell']" :phone="project['company_contact_cell']"
                                :masks="masks"/>
                        </a>
                        <a :href="editProject(project)"
                           class="text-dark hover:text-teal-dark"
                           v-show="column.property_name !== 'sequential_team_id' && column.property_name !== 'pre_bid' && column.property_name !== 'bid_date' && column.property_name !== 'marketing_status' && column.property_name !== 'lead_from' && column.property_name !== 'sales_statuses_code' && column.property_name !== 'login_date' && column.property_name !== 'contract_date'&& column.property_name !== 'dead_date' && column.property_name !== 'labor_hours' && column.property_name !== 'base_bid' && column.property_name !== 'contract_amount' && column.property_name !== 'gross_margin' && column.property_name !== 'contact_email' && column.property_name !== 'contact_phone' && column.property_name !== 'contact_cell' && column.property_name !== 'company_contact_cell' && column.property_name !== 'estimator_name' && column.property_name !== 'account_manager_name' && column.property_name !== 'take_off_person_name' && column.property_name !== 'products_and_services' && column.property_name !== 'client_profile' && column.property_name !== 'contract_type' && column.property_name !== 'office' && column.property_name !== 'comment' && column.property_name !== 'add_comment' && !column.is_custom_field"
                           :class="(column.property_name === 'name') ? 'fix-name-content' : ''"
                           :title="project[column.property_name]">
                            {{ project[column.property_name] }}
                        </a>
                        <a
                            :href="editProject(project)"
                            v-if="column.property_name === 'comment'"
                            :class="(column.property_name === 'name') ? 'fix-name-content' : ''"
                            :title="(project[column.property_name])? project[column.property_name]:''"
                            data-toggle="tooltip" data-placement="auto" data-html="true"
                            class="comment-tooltip"
                            v-html="project[column.property_name] ? project[column.property_name].length >= 20 ? project[column.property_name].substring(0,20) + '..' : project[column.property_name] : project[column.property_name]">
                        </a>
                        <span
                            @click.stop="column.property_name === 'add_comment'"
                            v-if="column.property_name === 'add_comment'"
                            class="hover:bg-grey-lighter text-center">

                            <inline-comment :projectColumn="column" :projects="project"
                                            :users="users"></inline-comment>

                        </span>

                        <span @click.stop="column.property_name === 'pin'"
                              v-if="column.property_name === 'pin'" class="hover:bg-grey-lighter text-center">

                              <pin-project :projectColumn="column" :projects="project"
                                           @fetchProjectData="fetchProjectData"
                                           @updateLoader="updateLoader"></pin-project>
                        </span>

                        <!--Project Inline Update-->

                        <span
                            @click.stop="column.property_name === 'sequential_team_id'"
                            v-if="column.property_name === 'sequential_team_id'"
                            class="text-teal hover:text-teal-dark cpi">

                            <p class="cpi_text text-center" @click="showEditBox($event.target)">{{ project[column.property_name] }} &nbsp;&nbsp;&nbsp;<i class="mr-1 fa fa-pencil" role="button" @click="showEditBox($event.target)"></i></p>

                            <input
                                style="display: none; width: 80%;"
                                id="sequential_team_id"
                                name="sequential_team_id"
                                @change="updateCustomProjectId(project[column.property_name],project,$event.target)"
                                v-model="project[column.property_name]"
                                class="rounded p-2 text-grey-darkest text-xs focus:outline-none border-none w-full bg-white"
                                :class="[(project.id == requiredFieldProjectId) ? 'required-field-missing' : '', (project['pin_project'] === 1) ? 'pin-project-highlighted' : '']" 
                                />
                            <i class="ml-1 fa fa-times" style="display: none;" role="button" @click="hideEditBox($event.target)"></i>

                        </span>
                        <span
                            @click.stop="column.property_name === 'base_bid' || column.property_name === 'contract_amount' || column.property_name === 'gross_margin' || column.property_name === 'labor_hours'"
                            v-if="column.property_name === 'base_bid' || column.property_name === 'contract_amount' || column.property_name === 'gross_margin' || column.property_name === 'labor_hours'"
                            class="hover:bg-grey-lighter">

                            <currency-input
                            id="base_bid"
                            name="base_bid"
                            v-model="project[column.property_name]"
                            disabled
                            v-on:change="inlineRecordUpdate(project[column.property_name],column.property_name,project)"
                                locale="us"
                                :currency="null"
                                class="rounded p-1 text-grey-darkest text-xs focus:outline-none hover:bg-grey-lighter border-none w-full"
                                :class="[(project.id == requiredFieldProjectId) ? 'required-field-missing' : '', (project['pin_project'] === 1) ? 'pin-project-highlighted' : '']">
                            </currency-input>

                        </span>

                        <span
                            @click.stop="column.property_name === 'login_date' || column.property_name === 'contract_date'|| column.property_name === 'dead_date'"
                            v-if="column.property_name === 'login_date'  || column.property_name === 'contract_date'|| column.property_name === 'dead_date'">
                             <datepicker v-model="project[column.property_name]" :format="masks.date_mask"
                                         :input-class="[(project.id == requiredFieldProjectId) ? 'required-field-missing' : '', (project['pin_project'] === 1) ? 'pin-project-highlighted' : '']"
                                         @keypress.enter.prevent="closeCalendar()"
                                         @input="inlineRecordUpdate(project[column.property_name],column.property_name,project)"></datepicker>
                        </span>

                        <span @click.stop="column.property_name==='sales_statuses_code'"
                              v-if="column.property_name==='sales_statuses_code'">
                              <select v-model="project.sales_status_id"
                              disabled
                              @change="getStatusValue($event,column.property_name,project)"
                                    :style="{'background-color':project.status_background_color, 'border' : project.status_border_color+' 1px solid'}"
                                    class="appearance-none p-1 border-none focus:outline-none rounded text-grey-darkest text-xs w-full"
                                    :class="[(project.id == requiredFieldProjectId) ? 'required-field-missing' : '', (project['pin_project'] === 1) ? 'pin-project-highlighted' : '','sales_statuses_code_'+project.id]">
                                <option selected></option>
                                <option v-for="item in selects.sales_status"
                                        :value="item.id">{{ item.full_description }}</option>
                            </select>
                        </span>
                        <span @click.stop="column.property_name==='marketing_status'"
                              v-if="column.property_name==='marketing_status'">
                            <select v-model="project.marketing_status_id"
                                    @change="getStatusValue($event,column.property_name,project)"
                                    class="appearance-none p-1 border-none focus:outline-none rounded text-grey-darkest text-xs w-full"
                                    :class="[(project.id == requiredFieldProjectId) ? 'required-field-missing' : '', (project['pin_project'] === 1) ? 'pin-project-highlighted' : '']">
                                    <option selected></option>
                                    <option v-for="item in selects.marketing_status"
                                            :value="item.id">{{ item.full_description }}</option>
                            </select>
                        </span>
                        <span @click.stop="column.property_name==='lead_from'"
                              v-if="column.property_name==='lead_from'">
                            <select v-model="project.lead_from_id"
                                    @change="getStatusValue($event,column.property_name,project)"
                                    class="appearance-none p-1 border-none focus:outline-none rounded text-grey-darkest text-xs w-full"
                                    :class="[(project.id == requiredFieldProjectId) ? 'required-field-missing' : '', (project['pin_project'] === 1) ? 'pin-project-highlighted' : '']">
                                    <option selected></option>
                                    <option v-for="item in selects.lead_from"
                                            :value="item.id">{{ item.full_description }}</option>
                            </select>
                        </span>
                        <span @click.stop="column.property_name==='estimator_name'"
                              v-if="column.property_name==='estimator_name'">
                            <select v-model="project.estimator_id"
                                    @change="getStatusValue($event,column.property_name,project)"
                                    class="appearance-none p-1 border-none focus:outline-none rounded text-grey-darkest text-xs w-full"
                                    :class="[(project.id == requiredFieldProjectId) ? 'required-field-missing' : '', (project['pin_project'] === 1) ? 'pin-project-highlighted' : '']">
                                    <option selected></option>
                                    <option v-for="item in selects.all_users" v-if="item.id === project.estimator_id || item.pivot.active" :value="item.id" :disabled="!item.pivot.active">
                                        {{ item.pivot.active ? item.name : item.name + ' - Inactive' }}
                                    </option>
                            </select>
                        </span>
                        <span @click.stop="column.property_name==='account_manager_name'"
                              v-if="column.property_name==='account_manager_name'">
                            <select v-model="project.account_manager_id"
                                    @change="getStatusValue($event,column.property_name,project)"
                                    class="appearance-none p-1 border-none focus:outline-none rounded text-grey-darkest text-xs w-full"
                                    :class="[(project.id == requiredFieldProjectId) ? 'required-field-missing' : '', (project['pin_project'] === 1) ? 'pin-project-highlighted' : '']">
                                    <option selected></option>
                                    <option v-for="item in selects.all_users" v-if="item.id === project.account_manager_id || item.pivot.active" :value="item.id" :disabled="!item.pivot.active">
                                        {{ item.pivot.active ? item.name : item.name + ' - Inactive' }}
                                    </option>
                            </select>
                        </span>
                        <span @click.stop="column.property_name==='take_off_person_name'"
                              v-if="column.property_name==='take_off_person_name'">
                            <select v-model="project.take_off_person_id"
                                    @change="getStatusValue($event,column.property_name,project)"
                                    class="appearance-none p-1 border-none focus:outline-none rounded text-grey-darkest text-xs w-full"
                                    :class="[(project.id == requiredFieldProjectId) ? 'required-field-missing' : '', (project['pin_project'] === 1) ? 'pin-project-highlighted' : '']">
                                    <option selected></option>
                                    <option v-for="item in selects.all_users" v-if="item.id === project.take_off_person_id || item.pivot.active" :value="item.id" :disabled="!item.pivot.active">
                                        {{ item.pivot.active ? item.name : item.name + ' - Inactive' }}
                                    </option>
                            </select>
                        </span>
                        <span @click.stop="column.property_name==='products_and_services'"
                              v-if="column.property_name==='products_and_services'">
                            <select v-model="project.products_and_services_id"
                                    @change="getStatusValue($event,column.property_name,project)"
                                    class="appearance-none p-1 border-none focus:outline-none rounded text-grey-darkest text-xs w-full"
                                    :class="[(project.id == requiredFieldProjectId) ? 'required-field-missing' : '', (project['pin_project'] === 1) ? 'pin-project-highlighted' : '']">
                                    <option selected></option>
                                    <option v-for="item in selects.products_and_services"
                                            :value="item.id">{{ item.full_description }}</option>
                            </select>
                        </span>
                        <span @click.stop="column.property_name==='client_profile'"
                              v-if="column.property_name==='client_profile'">
                            <select v-model="project.client_profile_id"
                                    @change="getStatusValue($event,column.property_name,project)"
                                    class="appearance-none p-1 border-none focus:outline-none rounded text-grey-darkest text-xs w-full"
                                    :class="[(project.id == requiredFieldProjectId) ? 'required-field-missing' : '', (project['pin_project'] === 1) ? 'pin-project-highlighted' : '']">
                                    <option selected></option>
                                    <option v-for="item in selects.client_profile"
                                            :value="item.id">{{ item.full_description }}</option>
                            </select>
                        </span>
                        <span @click.stop="column.property_name==='contract_type'"
                              v-if="column.property_name==='contract_type'">
                            <select v-model="project.contract_type_id"
                                    @change="getStatusValue($event,column.property_name,project)"
                                    class="appearance-none p-1 border-none focus:outline-none rounded text-grey-darkest text-xs w-full"
                                    :class="[(project.id == requiredFieldProjectId) ? 'required-field-missing' : '', (project['pin_project'] === 1) ? 'pin-project-highlighted' : '']">
                                    <option selected></option>
                                    <option v-for="item in selects.contract_type"
                                            :value="item.id">{{ item.full_description }}</option>
                            </select>
                        </span>
                        <span @click.stop="column.property_name==='office'" v-if="column.property_name==='office'">
                            <select v-model="project.office_id"
                                    @change="getStatusValue($event,column.property_name,project)"
                                    class="appearance-none p-1 border-none focus:outline-none rounded text-grey-darkest text-xs w-full"
                                    :class="[(project.id == requiredFieldProjectId) ? 'required-field-missing' : '', (project['pin_project'] === 1) ? 'pin-project-highlighted' : '']">
                                    <option selected></option>
                                    <option v-for="item in selects.office" :value="item.id">{{
                                            item.full_description
                                        }}</option>
                            </select>
                        </span>
                        <span @click.stop="column.property_name==='pre_bid'"
                              v-if="column.property_name==='pre_bid'">
                        <datepicker v-model="project.pre_bid" :format="masks.date_mask"
                                    :input-class="[(project.id == requiredFieldProjectId) ? 'required-field-missing' : '', (project['pin_project'] === 1) ? 'pin-project-highlighted' : '']"
                                    @keypress.enter.prevent="closeCalendar()"
                                    @input="getDateValue(column.property_name,project.pre_bid,project)"></datepicker>
                        </span>
                        <span @click.stop="column.property_name==='bid_date'"
                              v-if="column.property_name==='bid_date'">
                        <datepicker v-model="project.bid_date" :format="masks.date_mask"
                                    :input-class="[(project.id == requiredFieldProjectId) ? 'required-field-missing' : '', (project['pin_project'] === 1) ? 'pin-project-highlighted' : '']"
                                    @keypress.enter.prevent="closeCalendar()"
                                    @input="getDateValue(column.property_name,project.bid_date,project)"></datepicker>
                        </span>
                        <span @click.stop="column.is_custom_field===true"
                              v-if="column.is_custom_field===true && (column.custom_field_type === 'USER' || column.custom_field_type === 'DROPDOWN')">
                            <select :value="getCustomFieldValue(project.custom_field_data, column.custom_field_id)"
                                    @change="getStatusValue($event,column.custom_field_id,project,true)"
                                    class="appearance-none p-1 border-none focus:outline-none rounded text-grey-darkest text-xs w-full"
                                    :class="[(project.id == requiredFieldProjectId) ? 'required-field-missing' : '', (project['pin_project'] === 1) ? 'pin-project-highlighted' : '']">
                                    <option selected></option>
                                    <option v-for="item in column.custom_field_options"
                                            :value="item.id">{{ item.name }}</option>
                            </select>
                        </span>
                        <span @click.stop="column.is_custom_field===true"
                              v-if="column.is_custom_field===true && column.custom_field_type === 'TEXT'">
                            <input :value="getCustomFieldValue(project.custom_field_data, column.custom_field_id)"
                                   type="text"
                                   @change="getStatusValue($event,column.custom_field_id,project,true)"
                                   class="appearance-none p-1 border-none focus:outline-none rounded text-grey-darkest text-xs w-full"
                                   :class="[(project.id == requiredFieldProjectId) ? 'required-field-missing' : '', (project['pin_project'] === 1) ? 'pin-project-highlighted' : '']">
                        </span>
                        <span @click.stop="column.is_custom_field===true"
                              v-if="column.is_custom_field===true && column.custom_field_type === 'DATE'">
                            <datetime type="date"
                                      :value="getCustomFieldValue(project.custom_field_data, column.custom_field_id)"
                                      :use-utc="true"
                                      class="w-full"
                                      :format="masks.date_mask"
                                      :week-start="7"
                                      @input="getStatusValue($event,column.custom_field_id,project,true,column.custom_field_type)"
                                      :input-class="[(project.id == requiredFieldProjectId) ? 'required-field-missing' : '', (project['pin_project'] === 1) ? 'pin-project-highlighted' : '', 'appearance-none p-1 border-none focus:outline-none rounded text-grey-darkest text-xs w-full']">
                            </datetime>
                        </span>
                        <span @click.stop="column.is_sales_behavior===true" v-if="column.is_sales_behavior===true">
                            <datetime v-if="calendar" type="datetime"
                                      :value="getSalesBehaviorValue(project.sales_behaviors_data, column.sales_behavior_id)"
                                      :use-utc="true"
                                      use12-hour
                                      class="w-full"
                                      :format="masks.date_time_mask"
                                      :week-start="7"
                                      :minute-step="15"
                                      @input="saveSalesBehavior(column.sales_behavior_id, $event, project)"
                                      :input-class="[(project.id == requiredFieldProjectId) ? 'required-field-missing' : '', (project['pin_project'] === 1) ? 'pin-project-highlighted' : '', 'appearance-none p-1 border-none focus:outline-none rounded text-grey-darkest text-xs w-full']">
                            </datetime>
                            <datetime v-if="!calendar" type="date"
                                      :value="getSalesBehaviorValue(project.sales_behaviors_data, column.sales_behavior_id)"
                                      :use-utc="true"
                                      class="w-full"
                                      :format="masks.date_mask"
                                      :week-start="7"
                                      @input="saveSalesBehavior(column.sales_behavior_id, $event, project)"
                                      :input-class="[(project.id == requiredFieldProjectId) ? 'required-field-missing' : '', (project['pin_project'] === 1) ? 'pin-project-highlighted' : '', 'appearance-none p-1 border-none focus:outline-none rounded text-grey-darkest text-xs w-full']">
                            </datetime>
                        </span>

                        <!-- <inline-update :projectColumn="column" :projects="project" :masks="masks.date_mask" :selects="selects" :requiredFieldProjectIds="requiredFieldProjectId"></inline-update> -->

                        <!--Project Inline Update-->
                    </td>
                    <td class="pl-2 border-b border-grey-light text-xs hidden xl:table-cell md:table-cell"
                        :class="(project['pin_project'] === 1) ? 'pin-project-highlighted' : ''">
                        <div>{{ project.last_update }}</div>
                    </td>
                    <!-- <td class="px-4 border-b border-grey-light text-right hidden xl:table-cell md:table-cell"
                        :class="(project['pin_project'] === 1) ? 'pin-project-highlighted' : ''">
                        <span class="material-icons">chevron_right</span>
                    </td> -->
                </tr>


                    </tbody>
                </table>
            </div>
            <div class="flex justify-center">
                <div class="d-flex align-items-center mr-2">
                    Total of {{ pagination.meta.total }} records
                </div>
                <b-pagination
                    @change="goToPage"
                    v-model="pagination.meta.current_page"
                    :total-rows="pagination.meta.total"
                    :per-page="pagination.meta.per_page"
                    first-text="First"
                    prev-text="Prev"
                    next-text="Next"
                    last-text="Last"
                    v-if="pagination.meta.total > pagination.meta.per_page"
                >
                </b-pagination>
                <div class="d-flex align-item-center ml-2" v-if="pagination.meta.total > 0">
                    <b-form-select v-model="itemPerPage" :options="itemPerPageOptions" class="text-teal border-0 bg-transparent" @change="changeItemPerPage()"></b-form-select>
                </div>
            </div>
        </div>

        <div v-else class="mt-10 text-center">
            <div class="flex-col">
                <div>
                    <img width="400" src="images/empty.svg">
                </div>
                <div v-if="companyExists" class="mt-4">
                    <div class="text-lg text-grey-darkest mb-2 flex justify-center">
                        <div class="text-xl w-1/4 tracking-wide">You haven't added a project yet!</div>
                    </div>
                    <button @click="addProject"
                            class="bg-followup-nav px-4 py-2 rounded-full text-white focus:outline-none hover:bg-followup-nav-darker text-xl">
                        Click here to add your first project!
                    </button>
                </div>
                <div v-else class="mt-4">
                    <div class="text-lg text-grey-darkest mb-2 flex justify-center">
                        <div class="text-xl w-1/4 tracking-wide">You must add a company before adding a project.</div>
                    </div>
                    <button @click="addCompany"
                            class="bg-followup-nav px-4 py-2 rounded-full text-white focus:outline-none hover:bg-followup-nav-darker text-xl">
                        Click here to add your first company!
                    </button>
                </div>
            </div>
        </div>
        <div v-if="inline_update_loading || pin_project_loading"
             class="text-5xl text-grey-darkest text-center mt-32 inline_update_loading_class">
            <i class="fa fa-spin fa-spinner" aria-hidden="true"></i>
        </div>

    </div>
</template>

<script>
import FormattedPhone from '../../shared/formatted-phone.vue';
import draggable from 'vuedraggable';
import Datepicker from 'vuejs-datepicker';
import inlineUpdate from "../../project/inline-update/inline-update";
import inlineComment from "../../project/inline-update/inline-comment";
import pinProject from "../../project/pin-project/pin-project";
import Form from "../../../utils/form";
import CKEditorContainer from '../../shared/ckeditor-container';


export default {
    name: 'custom-project-id-index',
    props: {
        companyExists: {
            type: Boolean
        },
        userLegacy: {
            type: Boolean
        },
        projectManagement: {
            type: Boolean,
            required: false,
            default: false
        },
        masks: {},
        state: {
            type: Array,
        },
        // customFields: {
        //     type: Array,
        // },
        availableColumns: {
            type: Array,
        },
        availableSort: {},
        // hasStackAccessToken: {
        //     type: Boolean
        // },
        // editUrl: {
        //     type: Boolean
        // },
        userRole:{},
        calendar:{},
        symbols: {},
        exchange: {},
        canDelete: {},
        // customFieldTypeConstants: {},
        // salesBehaviors: {
        //     type: Array,
        // },
        fieldLabels: {},
        hasBulkEmailAccess: {},
        userItemPerPage:{}
    },
    components: {Datepicker, draggable, inlineUpdate, inlineComment, pinProject,CKEditorContainer},
    data() {
        let projectState = this.state
        projectState = projectState.filter((state) => {
            return (state.property_name !== "age" && state.property_name !== "meeting_date")
        })
        return {
            customProjectIdRegExp: '',
            projects: '',
            companies: '',
            filter: {
                project_name: '',
                timeout: null,
                advanced: false,
                project_management: this.projectManagement
            },
            page: 1,
            pagination: {
                data: [],
                meta: {},
                links: {},
            },
            currentOrder: {
                sortBy: 'last_update',
                direction: 'desc'
            },
            data_loading: true,
            zero_search_results: false,
            show_advanced_search: false,
            current_search_pattern: '',
            check_all: false,
            check_current: false,
            checked_project_ids: [],
            checked_current_project_ids: [],
            columns: projectState,
            columnsToShow: null,
            availableSortingColumns: {},
            columnsToExport: projectState,
            isViewState: false,
            view: {},
            allProjectIds:[],
            currentProjectIds:[],
            projectViewList:[],
            projectViewId:'',
            projectViewName:'',
            showError:'',
            drag: false,
            advancedSearchViewFilterProjectData: {},
            advancedSearchViewFilterProjectCustomFields: {},
            uncheckedProjectIds: [],
            uncheck_all: true,
            uncheck_current: true,
            selects: {
                decision_process: [],
                find_problems: [],
                money_step: [],
                pm_users: [],
                relate_and_connect: [],
                rules_of_engagement: [],
                sales_status: [],
                marketing_status: [],
                lead_from: [],
                products_and_services: [],
                client_profile: [],
                contract_type: [],
                office: [],
                users: []
            },
            requiredFieldProjectId: null,
            users: [],
            inline_update_loading: false,
            pin_project_loading: false,
            payload: {},
            salesBehaviorCount: 0,
            pageLoaded: 0,
            user_bulk_email_limit: 0,
            width : null,
            itemPerPage: (this.userItemPerPage)? this.userItemPerPage.project:15,
            itemPerPageOptions: [
                { value: 15, text: '15 per page' },
                { value: 25, text: '25 per page' },
                { value: 50, text: '50 per page' },
                { value: 100, text: '100 per page' },
            ],
            isCodesLoaded: false,
            emptyContractAmountProject: {},
            sales_status: null,
            checkCommentStatus:null,
            projectCommentForm: new Form({
                id: null,
                comment: '',
                date: '',
                project_id: null,
                company_contact_id: null,
                sales_status_id: null,
                mentioned_users: [],
                saving: false,
                commentAddFrom:null,
            }),
        }
    },
    watch: {
        // check_all: function(val){
        //     if(val) {
        //         this.checkAll();
        //     }
        // },
        // check_current: function(val){
        //     this.checkCurrent(val);
        // }
    },
    created() {
        // this.fetchCodes();
        // this.fetchProjectsView();
        this.getWidth();
        this.fetchData();
        // if(!this.availableSort) {
        //     this.fetchAvailableSort();
        // }
        // this.fetchTeamUsers();
    },
    mounted() {
        this.columnsToShow = this.availableColumns;
        this.availableSortingColumns = this.availableSort;
        this.customProjectIdRegExp = this.getCustomProjectIdRegEx();
    },
    methods: {
        // fetchAvailableSort() {
        //     axios.get(route('api.project.available-sort')).then(({data}) => {
        //         this.availableSort = data.availableSorts;
        //     })
        // },
        getCustomProjectIdRegEx() {
            if(!this.$root.currentTeam.custom_project_id_check)
            return '';

            let state = this.$root.currentTeam.custom_project_id ? JSON.parse(this.$root.currentTeam.custom_project_id) : [];
            const customId = []; //     '^\\S+@\\S+$'
            var other = '';
            for (const element of state) {
                switch (element.id) {
                    case 'year':
                        if (element.value === true) {
                            if (element.sequential === true) {
                                customId.push('\\d{4}');
                            } else if (element.start_from === true) {
                                let year = element.input_value;
                                let exp = '\\d{'+year.length+',}';  // '\\d{4,}'
                                customId.push(exp);
                            }
                        }
                        break;
                    case 'month':
                        if (element.value === true) {
                            if (element.sequential === true) {
                                customId.push('\\d{2}');
                            } else if (element.start_from === true) {
                                let month = element.input_value;
                                let exp = '\\d{'+month.length+',}';  // '\\d{2,}'
                                customId.push(exp);
                            }
                        }
                        break;
                    case 'day':
                        if (element.value === true) {
                            if (element.sequential === true) {
                                customId.push('\\d{2}');
                            } else if (element.start_from === true) {
                                let day = element.input_value;
                                let exp = '\\d{'+day.length+',}';  // '\\d{2,}'
                                customId.push(exp);
                            }
                        }
                        break;
                    case 'system_generated':
                        if (element.value === true) {
                            let system_generated = element.input_value;
                            let exp = '\\d{'+system_generated.length+',}';  // '\\d{2,}'
                            customId.push(exp);
                        }
                        break;
                    case 'other':
                        if (element.value === true) {
                            if (element.seperated_by_dash === true) {
                                var other = '-';
                            } else if (element.seperated_by_space === true) {
                                var other = '/';
                            } else {
                                var other = '';
                            }
                        } else {
                            var other = '';
                        }
                        break;
                }
            }
            if (other == '-') {
                var customProjectIdRegEx = '^' + customId.join("-") + '$';
            }
            if (other == '/') {
                var customProjectIdRegEx = '^' + customId.join(" ") + '$';
            }
            if (other == '') {
                var customProjectIdRegEx = '^' + customId.join("") + '$';
            }
            return customProjectIdRegEx || '';
        },
        showEditBox(el) {
            let inpt = $(el).closest('.cpi').find('input');
            $(el).closest('.cpi').find('.fa-times').show();
            inpt.show();
            inpt.focus();
            $(el).closest('.cpi').find('.cpi_text').hide();
        },
        hideEditBox(el) {
            if(!this.inline_update_loading){
                $(el).closest('.cpi').find('input').hide();
                $(el).closest('.cpi').find('.fa-times').hide();
                $(el).closest('.cpi').find('.cpi_text').show();
            }
        },
        updateCustomProjectId(customProjectId, project, el) {

            if(this.customProjectIdRegExp && !customProjectId.match(this.customProjectIdRegExp)){
                this.getToast(5000).fire({
                    type: 'error',
                    title: "Project custom ID needs to match format set in the settings."
                });
                return false;
            }
            this.inline_update_loading = true;

            let payload = {
                'custom_project_id': customProjectId,
                'project_id': project.id
            }


            axios.post(route('api.project.update-custom-project-id'), payload)
                .then(response => {
                    if (response) {
                        this.inline_update_loading = false;
                        if(el) this.hideEditBox(el);
                    }
                }).catch(error => {
                if (error) {
                    this.inline_update_loading = false;
                    let self = this;
                }
                this.getToast(5000).fire({
                    type: 'error',
                    title: "Error! Could not update project custom ID. Entered ID is already assigned to another project."
                });
            })
        },
        inlineRecordUpdate(propertyValue, propertyType, project) {

            if (propertyType === 'login_date' || propertyType === 'dead_date' || propertyType === 'contract_date') {
                propertyValue = moment(propertyValue).local().format('YYYY-MM-DD')
            }

            let payload = {
                'inlineColumnType': propertyType,
                'inlineColumnValue': propertyValue,
                'project': project
            }

            this.inline_update_loading = true;

            axios.post(route('inline-record-update'), payload)
                .then(response => {
                    if (response) {
                        this.inline_update_loading = false;

                        let self = this;
                        setTimeout(function () {
                            self.projectUpdatedData(payload);
                        }, 3000);

                        
                    }
                }).catch(error => {
                if (error) {
                    this.inline_update_loading = false;
                    let self = this;
                    setTimeout(function () {
                        self.projectUpdatedData(payload);
                    }, 3000);
                }

                

                this.requiredFieldProjectId = payload.project.id;

                    // Bus.$emit('sendRequiredFieldProjectId', this.requiredFieldProjectId);

                this.getToast(5000).fire({
                    type: 'error',
                    title: "Required field must be updated in order to update this field.\nPlease drill into the project to update."
                });


                let self = this;
                setTimeout(function () {
                    self.requiredFieldProjectId = null;
                }, 5000);
            })
        },
        goToPage(page) {
            this.page = page;
            this.fetchProjects(this.current_search_pattern, this.page);
        },
        sortByColumn(sortBy) {
            if (sortBy === this.currentOrder.sortBy) {
                this.currentOrder.direction = (this.currentOrder.direction === 'asc') ? 'desc' : 'asc'
            } else {
                this.currentOrder.sortBy = sortBy
                this.currentOrder.direction = 'desc';
            }
            localStorage.setItem('projects.sortBy', this.currentOrder.sortBy);
            localStorage.setItem('projects.direction', this.currentOrder.direction);
            this.fetchProjects(this.current_search_pattern);
        },
        fetchData() {
            // if (new URLSearchParams(window.location.search).has('search')) {
            //     if (localStorage.getItem('projects.advanced_filter')) {
            //         this.current_search_pattern = JSON.parse(localStorage.getItem('projects.advanced_filter'));
            //     } else if (localStorage.getItem('projects.project_name')) {
            //         this.filter.project_name = localStorage.getItem('projects.project_name');
            //     }
            //     this.page = localStorage.hasOwnProperty('projects.page') ? localStorage.getItem('projects.page') : 1;
            //     this.currentOrder.sortBy = localStorage.hasOwnProperty('projects.sortBy') ? localStorage.getItem('projects.sortBy') : 'last_update';
            //     this.currentOrder.direction = localStorage.hasOwnProperty('projects.direction') ? localStorage.getItem('projects.direction') : 'desc';
            //     this.fetchProjects(this.current_search_pattern, this.page);
            // } else {
                // if (this.editUrl) {
                //     this.page = localStorage.hasOwnProperty('projects.page') ? localStorage.getItem('projects.page') : 1;
                // } else {
                this.page = 1;
                // }
                // localStorage.removeItem('projects.advanced_filter');
                // localStorage.removeItem('projects.project_name');
                // localStorage.removeItem('projects.page');
                // localStorage.removeItem('projects.sortBy');
                // localStorage.removeItem('projects.direction');
                // localStorage.removeItem('projects.view_filter_id');
                this.currentOrder.sortBy = 'last_update';
                this.currentOrder.direction = 'desc';
                // localStorage.removeItem('projects.project_name')
                this.fetchProjects(null, this.page);
            // }
        },
        fetchPinProjectData() {
            if (new URLSearchParams(window.location.search).has('search') || localStorage.getItem('projects.project_name') || localStorage.getItem('projects.advanced_filter')) {
                if (localStorage.getItem('projects.advanced_filter')) {
                    this.current_search_pattern = JSON.parse(localStorage.getItem('projects.advanced_filter'));
                } else if (localStorage.getItem('projects.project_name')) {
                    this.filter.project_name = localStorage.getItem('projects.project_name');
                }
                this.page = localStorage.hasOwnProperty('projects.page') ? localStorage.getItem('projects.page') : 1;
                this.currentOrder.sortBy = localStorage.hasOwnProperty('projects.sortBy') ? localStorage.getItem('projects.sortBy') : 'last_update';
                this.currentOrder.direction = localStorage.hasOwnProperty('projects.direction') ? localStorage.getItem('projects.direction') : 'desc';
                this.fetchProjects(this.current_search_pattern, this.page);
            } else {
                // if (this.editUrl) {
                //     this.page = localStorage.hasOwnProperty('projects.page') ? localStorage.getItem('projects.page') : 1;
                // } else {
                this.page = 1;
                // }
                localStorage.removeItem('projects.advanced_filter');
                localStorage.removeItem('projects.view_filter_id');
                localStorage.removeItem('projects.project_name');
                localStorage.removeItem('projects.page');
                localStorage.removeItem('projects.sortBy');
                localStorage.removeItem('projects.direction');
                this.currentOrder.sortBy = 'last_update';
                this.currentOrder.direction = 'desc';
                localStorage.removeItem('projects.project_name')
                this.fetchProjects(null, this.page);
            }
        },
        fetchProjects(filter = null, page = 1) {
            const self = this;
            if (filter) {
                this.current_search_pattern = filter;
                this.filter.project_name = '';
                localStorage.removeItem('projects.project_name');
                // localStorage.setItem('projects.advanced_filter', JSON.stringify(filter));
            }
            this.page = page;
            localStorage.setItem('projects.page', page);
            this.show_advanced_search = false;
            let params = {
                filter: filter ? filter : {
                    ...this.filter,
                    project_name: this.filter.project_name ?
                        this.filter.project_name : ''
                },
                page: this.page,
                sortBy: this.currentOrder.sortBy,
                direction: this.currentOrder.direction,
                perPage: this.itemPerPage,
                columns: this.availableColumns ? this.availableColumns.map(obj => obj.property_name) : []
            };
            this.data_loading = true;
            axios.get(route('api.project.index'), {params}).then(({data}) => {
                // console.log(data.availableSorts);
                // this.columnsToShow = data.availableColumns;
                // this.availableSortingColumns = data.availableSorts;
                this.projects            = data.data;
                this.allProjectIds       = data.meta.allProjectIds;
                this.currentProjectIds       = data.meta.currentProjectIds;
                this.pagination          = data;
                this.data_loading        = false;
                this.zero_search_results = (this.filter && this.projects.length === 0);
                this.user_bulk_email_limit = data.meta.user_bulk_email_limit;
                // this.fetchFullCurrentList(params);
                localStorage.setItem('current_project_list', JSON.stringify(data.project_ids));
                if (this.check_all) {
                    this.checkAll();
                }
                this.check_current = !self.currentProjectIds.some(function(item) {
                    return self.checked_project_ids.indexOf(item) === -1;
                });
                $(function () {
                    $("[data-toggle='tooltip']").tooltip('dispose');
                    $(".comment-tooltip").tooltip();
                });

                if(!this.isCodesLoaded) {
                    this.fetchCodes();
                    // this.fetchProjectsView();
                }
            });
        },
        fetchFullCurrentList(params) {
            axios.get(route('api.project.full-current-list'), {params}).then(({data}) => {
                localStorage.setItem('current_project_list', JSON.stringify({data}));
            })
        },
        debounceFilter(event) {
            clearTimeout(this.filter.timeout);
            this.filter.timeout = setTimeout(() => {
                this.filterByName(event.target.value);
            }, 700, this);
        },
        filterByName(name) {
            this.filter.project_name = name;
            localStorage.setItem('projects.project_name', name);
            this.current_search_pattern = null;
            localStorage.removeItem('projects.advanced_filter');
            localStorage.removeItem('projects.view_filter_id');
            // this.$refs.advancedSearchModule.clear();
            this.fetchProjects();
        },
        editProject(project) {
            let url = '';
            if (project.id){
                if (this.projectManagement) {
                    url = route('project-management.project.edit', {project: project.id});
                } else {
                    url = route('project.edit', {project: project.id}) + `?project=1`;
                }
            }
            return url;
        },
        addProject() {
            window.location = route('project.create');
        },
        addCompany() {
            window.location = route('company.create');
        },
        saveSearchPatternModal() {
            this.$refs.savePatternModal.open(this.current_search_pattern);
        },
        useSavedSearchPatternModal() {
            this.$refs.usePatternModal.open();
        },
        clearSearch() {
            this.current_search_pattern = null;
            localStorage.removeItem('projects.advanced_filter');
            localStorage.removeItem('projects.view_filter_id');
            // this.$refs.advancedSearchModule.clear();
            this.filter = {
                project_name: '',
                timeout: null,
                advanced: false,
                project_management: this.projectManagement
            };
            localStorage.setItem('last_name_search', '');
            this.fetchData();
        },
        checkAll(val) {
            if(val) {
                this.check_all = true;
                this.checked_project_ids = this.allProjectIds;
            }else{
                this.check_all = false;
                if(this.check_current) {
                    this.checked_project_ids = this.currentProjectIds;
                }else{
                    this.checked_project_ids = [];
                }
            }
        },
        checkCurrent(val) {

            if(val){
                this.check_current = true;
                this.checked_project_ids = this.currentProjectIds;
            }else{
                this.check_current = false;
                if(this.check_all){
                    this.checked_project_ids = this.allProjectIds;
                }else{
                    this.checked_project_ids = [];
                }
            }
        },
        // clearChecked() {
        //     this.check_all = false;
        //
        //     if(this.check_current) {
        //         this.checked_project_ids = this.currentProjectIds;
        //     }else{
        //         this.checked_project_ids = [];
        //     }
        // },
        // clearCurrentChecked() {
        //     this.check_current = false;
        //     if(this.check_all){
        //         this.checked_project_ids = this.allProjectIds;
        //     }else{
        //         this.checked_project_ids = [];
        //     }
        // },
        checkProject() {
            this.check_all = false;
            this.check_current = false;
        },
        updateAssignedUsersModal() {
            if (this.checked_project_ids.length) {
                this.$refs.updateAssignedUsersModal.open();
                return;
            }
            this.noProjectsCheckedAlert();
        },
        updateAddActivityModal() {
            if (this.checked_project_ids.length) {
                this.$refs.updateAddActivityModal.open();
                return;
            }
            this.noProjectsCheckedAlert();
        },
        updateFieldUpdateModal() {
            if (this.checked_project_ids.length) {
                this.$refs.updateFieldUpdateModal.open();
                return;
            }
            this.noProjectsCheckedAlert();
        },
        updateAddCompanyModal() {
            if (this.checked_project_ids.length) {
                this.$refs.updateAddCompanyModal.open();
                return;
            }
            this.noProjectsCheckedAlert();
        },
        sendBulkEmail() {
            if (this.checked_project_ids.length) {

                if(this.checked_project_ids.length > this.user_bulk_email_limit) {
                    this.getToast().fire({
                        type: 'error',
                        title: "Your remaining daily bulk email limit is " + this.user_bulk_email_limit
                    });
                    return false;
                }

                this.$refs.sendBulkEmail.open();
                return;
            }
            this.noProjectsCheckedAlert();
        },
        updateMasterClientModal() {
            if (this.checked_project_ids.length) {
                this.$refs.updateMasterClientModal.open();
                return;
            }
            this.noProjectsCheckedAlert();
        },
        massUpdateFinished(data) {
            // this.clearChecked();
            Swal.fire({
                title: 'Success!',
                text: data.message,
                type: 'success',
                showCancelButton: false,
                confirmButtonColor: '#01B1AF',
                confirmButtonText: 'OK!',
                closeOnConfirm: true,
            }).then(result => {
                window.location.reload();
            });
        },
        noProjectsCheckedAlert() {
            Swal.fire({
                title: 'No projects selected!',
                text: "First, select the projects you want to update.",
                type: 'error',
                showCancelButton: false,
                confirmButtonColor: '#01B1AF',
                confirmButtonText: 'OK!',
                closeOnConfirm: true,
            });
        },
        exportToExcel() {
            const Toast = Swal.mixin({
                toast: true,
                position: 'top-end',
                showConfirmButton: false,
                timer: 3000
            });
            axios.post(route('project.excel'), {
                "filter": this.current_search_pattern,
                "name": 'Projects',
                "time_zone": Intl.DateTimeFormat().resolvedOptions().timeZone,
                "columns": this.columnsToExport.map(column => ({
                    name: column.name,
                    property_name: column.property_name
                })),
            }).then(response => {
                Toast.fire({
                    type: 'success',
                    title: 'Your report is being processed and will be available soon on your notifications.'
                });
            }).catch(error => {
                if (error.response.status === 403) {
                    return Toast.fire({
                        type: 'warning',
                        title: 'You are not authorized to proceed with this action. Please contact your administrator.'
                    });
                }
                Toast.fire({
                    type: 'danger',
                    title: 'An error has occurred. Please contact your administrator.'
                });
            });
        },
        updateColumnState(updatedStates) {
            this.columnsToExport = updatedStates.filter((updatedState) => {
                if (updatedState.checked) {
                    return updatedState
                }
            })
        },
        SaveNewViewInfo(filter = null, page = 1) {
            const Toast = Swal.mixin({
                toast: true,
                position: 'top-end',
                showConfirmButton: false,
                timer: 2000
            });
            if (filter) {
                this.current_search_pattern = filter;
                this.filter.project_name = '';
                localStorage.removeItem('projects.project_name');
                localStorage.removeItem('projects.view_filter_id');
                localStorage.setItem('projects.advanced_filter', JSON.stringify(filter));
            }
            this.page = page;
            localStorage.setItem('projects.page', page);
            let params = {
                filter: filter ? filter : {
                    ...this.filter,
                    project_name: this.filter.project_name ?
                        this.filter.project_name :
                        localStorage.getItem('projects.project_name')
                },
                page: this.page,
                sortBy: this.currentOrder.sortBy,
                direction: this.currentOrder.direction,
                newView: filter.new_view,
                state: this.columnsToExport

            };
            axios.post(route('api.project.create-project-view'), params).then(response => {
                this.show_advanced_search = false;
                this.fetchProjectsView();
                Toast.fire({
                    type: 'success',
                    title: response.data.message
                });
            })
        },
        fetchProjectsViewColumnChange(viewId) {
            axios.get(route('api.project.project-view-list'))
                .then(({data}) => {
                    this.projectViewList = data.data;
                    this.onUpdate();
                    let viewFilter = _.find(data.data,  { 'id': parseInt(viewId) });
                    if (viewFilter){
                        this.applyFilter(viewFilter);
                    }else {
                        window.location.reload();
                    }
                });
        },
        fetchProjectsView() {
            axios.get(route('api.project.project-view-list'))
                .then(({data}) => {
                    this.projectViewList = data.data
                    this.onUpdate();
                });
        },
        getFilterProject() {
            axios.get(route('api.project.project-view-list'))
                .then(({data}) => {
                    this.projectViewList = data.data
                });
        },
        OpenRenameProjectView(view) {
            $("#RenameView").modal("show");
            this.projectViewId = view.id;
            this.projectViewName = view.name;
        },
        renameProjectView() {
            const Toast = Swal.mixin({
                toast: true,
                position: 'top-end',
                showConfirmButton: false,
                timer: 2000
            });
            if (this.projectViewName.replace(/\s/g, '') === '') {
                this.showError = 'Name field is required'
                return
            }
            this.showError = ''
            let params = {
                name: this.projectViewName,
                id: this.projectViewId
            };
            axios.post(route('api.project.rename-project-view'), params).then(response => {
                this.projectViewName = '';
                this.projectViewId = '';
                this.fetchProjectsView();
                Toast.fire({
                    type: 'success',
                    title: response.data.message
                });
            })
            $('#RenameView').modal('hide');
        },
        deleteProjectView(view_id) {
            const Toast = Swal.mixin({
                toast: true,
                position: 'top-end',
                showConfirmButton: false,
                timer: 2000
            });
            let self = this;
            Swal.fire({
                title: "Are you sure?",
                text: "Once deleted, you will not be able to recover this project lists!",
                icon: "warning",
                buttons: true,
                showCancelButton: true,
                confirmButtonColor: 'red',
                confirmButtonText: 'I\'m sure!',
                closeOnConfirm: true,
                closeOnCancel: true,
            }).then(result => {
                if (result.value) {
                    axios.delete(route('api.project.destroy-project-view', {
                        projectViewId: view_id
                    })).then((response) => {
                            self.fetchProjectsView();
                            Toast.fire({
                                type: 'success',
                                title: response.data.message
                            });
                        }
                    )
                }
            });
        },
        applyFilter(view) {
            this.fetchProjects(view.filter, 1);

            let filter = JSON.parse(view.filter);


            this.advancedSearchViewFilterProjectData = filter;
            this.isViewState = true;
            localStorage.setItem('projects.view_filter_id', view.id);
            this.view = view;
            if (view.state) {
                this.columns = view.state;
                this.columnsToExport = view.state;
                this.getColumnToShowArray(view);
            }else {
                let projectState = this.state
                projectState = projectState.filter((state) => {
                    return (state.property_name !== "age" && state.property_name !== "meeting_date")
                })
                this.columns = projectState;
                this.columnsToExport = projectState;
                 this.columnsToShow = this.availableColumns;
            }
            this.advancedSearchViewFilterProjectData.advanced = true;
            this.advancedSearchViewFilterProjectData.pre_bid = {start: filter.pre_bid.start, end: filter.pre_bid.end};
            this.advancedSearchViewFilterProjectData.bid_date = {
                start: filter.bid_date.start,
                end: filter.bid_date.end
            };
            this.advancedSearchViewFilterProjectData.contract_date = {
                start: filter.contract_date.start,
                end: filter.contract_date.end
            };
            this.advancedSearchViewFilterProjectData.login_date = {
                start: filter.login_date.start,
                end: filter.login_date.end
            };
            this.advancedSearchViewFilterProjectData.dead_date = {
                start: filter.dead_date.start,
                end: filter.dead_date.end
            };
            this.advancedSearchViewFilterProjectCustomFields = JSON.parse(filter.custom_fields);
        },
        getColumnToShowArray(view){
            let params={
                id: view.id,
            };
            axios.post(route('api.project.project-view-state'), params).then(response => {
                this.columnsToShow = response.data.data;
            })
        },
        onUpdate() {
            let self = this;
            self.projectViewList.forEach((viewList, index) => {
                viewList.load_order = index;
            });
            axios.put(route('api.project.view-list-order'), self.projectViewList);
        },
        massProjectDestroy() {

            if (this.canDelete) {

                let params = {
                    project_ids: this.checked_project_ids
                };

                let titleString = this.checked_project_ids.length == 1 ? this.checked_project_ids.length + ' project is selected, are you sure you want to delete it?' : this.checked_project_ids.length + ' projects are selected, are you sure you want to delete them?';
                let textString = this.checked_project_ids.length == 1 ? 'Record' : 'Records';

                Swal.fire({
                    title: titleString,
                    text: textString+" can't be undo once deleted",
                    type: 'warning',
                    showCancelButton: true,
                    confirmButtonColor: '#01B1AF',
                    confirmButtonText: 'Yes, delete it!'
                }).then((result) => {
                    if (result.value) {
                        axios({
                            method: "post",
                            url: "api/project/mass-update/delete-project",
                            data: params,
                        })
                            .then(function (response) {
                                Swal.fire({
                                    title: 'Deleted',
                                    text: 'The selected projects will be deleted shortly!',
                                    type: 'success'
                                }).then(() => {
                                    window.location.reload();
                                });
                            })
                            .catch(function (response) {
                                //
                            });
                    }
                });
            }
        },
        fetchCodes() {
            axios.get(route('api.project.codes')).then(({data}) => {
                this.selects = data;
                this.isCodesLoaded = true;
            });
        },
        projectUpdatedData(payload) {
            axios.post(route('project-updated-data'), payload).then(response => {
                this.projects = _.map(this.projects, function (project) {
                    if (project.id == payload.project.id) {
                        project.contract_amount = response.data.contract_amount;
                        project.base_bid = response.data.base_bid;
                        project.labor_hours = response.data.labor_hours;
                        project.gross_margin = response.data.gross_margin;
                        project.login_date = response.data.project.login_date;
                        project.contract_date = response.data.project.contract_date;
                        project.dead_date = response.data.project.dead_date;
                        project.sales_status_id = response.data.project.sales_status_id;
                        project.marketing_status_id = response.data.project.marketing_status_id;
                        project.lead_from_id = response.data.project.lead_from_id;
                        project.estimator_id = response.data.project.estimator_id;
                        project.account_manager_id = response.data.project.account_manager_id;
                        project.take_off_person_id = response.data.project.take_off_person_id;
                        project.products_and_services_id = response.data.project.products_and_services_id;
                        project.client_profile_id = response.data.project.client_profile_id;
                        project.contract_type_id = response.data.project.contract_type_id;
                        project.office_id = response.data.project.office_id;
                        project.pre_bid = response.data.pre_bid;
                        project.bid_date = response.data.bid_date;
                        project.custom_field_data = response.data.custom_field_data;
                        project.sales_behaviors_data = response.data.sales_behaviors_data;
                    }
                    return project;
                });
                this.inline_update_loading = false;
            });
        },
        // fetchTeamUsers() {
        //     axios.get(route('api.team-users')).then(({data}) => {
        //         this.users = data;
        //     })
        // },
        getStatusValue(event, projectColumn, project, isCustomField = false, type = '') {
            let self = this;
            projectColumn = self.getRenameColumn(projectColumn);
            if (event) {
                let valueItem = '';
                let dateFormat = 'MM/DD/yyyy';
                if (type !== 'DATE') {
                    valueItem = event.target.value;
                    self.payload = {
                        'inlineColumnType': projectColumn,
                        'inlineColumnValue': valueItem,
                        'project': project,
                        'isCustomField': isCustomField,
                    }
                    if (projectColumn === "sales_status_id"){
                        let salesStatus = self.selects.sales_status.find(x => x.id == valueItem);
                        self.emptyContractAmountProject = project;
                        self.adjustTextColor(project,valueItem);
                        if (salesStatus !== undefined && salesStatus !== null && salesStatus.contract && project.contract_amount == null) {

                            Swal.fire({
                                    icon: 'warning',
                                    title: 'Warning!',
                                    text: "Add Contract Amount to change the Sales Status to Contract",
                                    showCancelButton: true,
                                    confirmButtonColor: '#4dc0b5',
                                    confirmButtonText: 'Go To Project',
                                    cancelButtonText: 'Cancel',
                                    reverseButtons: true,
                                })
                                .then((result) => {
                                    if (result.value) {
                                        window.location = self.editProject(project);
                                    } else {
                                        self.projectUpdatedData(self.payload);
                                    }
                                });
                            return false;
                        }
                        if(salesStatus !== undefined && salesStatus !== null && salesStatus.comment && self.checkCommentStatus != project.id){
                            self.projectCommentForm.reset();
                            self.projectCommentForm.sales_status = salesStatus;
                            self.projectCommentForm.sales_status_id = salesStatus.id;
                            self.projectCommentForm.project_id = project.id;
                            self.addComment();
                            return false;
                        }

                    }
                    self.sendPostRequest();
                } else {
                    valueItem = event;
                    _.each(project.custom_field_data, function (customField) {
                        if (customField.id == projectColumn && valueItem && valueItem != "" && moment(customField.value).format(dateFormat) !== moment(valueItem).format(dateFormat)) {
                            self.payload = {
                                'inlineColumnType': projectColumn,
                                'inlineColumnValue': valueItem,
                                'project': project,
                                'isCustomField': isCustomField,
                            }
                            self.sendPostRequest();
                        }
                    });
                }

            }
        },
        getDateValue(propertyType, propertyValue, project) {
            propertyValue = moment(propertyValue).local().format('YYYY-MM-DD');
            this.payload = {
                'inlineColumnType': propertyType,
                'inlineColumnValue': propertyValue,
                'project': project
            }
            this.sendPostRequest();
        },
        sendPostRequest() {
            this.inline_update_loading = true;
            axios.post(route('inline-record-update'), this.payload).then(response => {
                if (response) {
                    let self = this;
                    setTimeout(function () {
                        self.projectUpdatedData(self.payload);
                    }, 3000);
                }

            }).catch(error => {
                if (error) {
                    this.inline_update_loading = false;
                    let self = this;
                    setTimeout(function () {
                        self.projectUpdatedData(self.payload);
                    }, 3000);
                }
                this.requiredFieldProjectId = this.payload.project.id;

                Bus.$emit('sendRequiredFieldProjectId', this.requiredFieldProjectId);

                this.getToast(5000).fire({
                    type: 'error',
                    title: "Required field must be updated in order to update this field.\nPlease drill into the project to update."
                });
            })
        },
        getRenameColumn(colunmHeading) {
            let columnVal = '';
            switch (colunmHeading) {
                case 'marketing_status':
                    columnVal = 'marketing_status_id';
                    break
                case 'sales_statuses_code':
                    columnVal = 'sales_status_id';
                    break
                case 'lead_from':
                    columnVal = 'lead_from_id';
                    break
                case 'estimator_name':
                    columnVal = 'estimator_id';
                    break
                case 'account_manager_name':
                    columnVal = 'account_manager_id';
                    break
                case 'take_off_person_name':
                    columnVal = 'take_off_person_id';
                    break
                case 'products_and_services':
                    columnVal = 'products_and_services_id';
                    break
                case 'client_profile':
                    columnVal = 'client_profile_id';
                    break
                case 'contract_type':
                    columnVal = 'contract_type_id';
                    break
                case 'office':
                    columnVal = 'office_id';
                    break
                default:
                    columnVal = colunmHeading;
                    break
            }
            return columnVal;
        },
        getCustomFieldValue(customFieldsData, fieldId) {

            for (var i = 0; i < customFieldsData.length; i++) {

                if (customFieldsData[i].id === fieldId) {

                    return customFieldsData[i].value;
                }
            }
        },

        fetchProjectData() {
            this.fetchPinProjectData();
        },

        updateLoader(value) {
            this.pin_project_loading = value;
        },
        getSalesBehaviorValue(salesBehaviorData, fieldId) {

            for (var i = 0; i < salesBehaviorData.length; i++) {

                if (salesBehaviorData[i].id === fieldId) {

                    return salesBehaviorData[i].value;
                }
            }
        },
        saveSalesBehavior(salesBehaviorId, propertyValue, project) {

            const self = this;
            let dateFormat = '';

            if (this.calendar) {

                dateFormat = 'MM/DD/yyyy hh:mm:ss a';
            } else {

                dateFormat = 'MM/DD/yyyy';
            }

            _.each(project.sales_behaviors_data, function (salesBehavior) {

                if (salesBehavior.id == salesBehaviorId && propertyValue && propertyValue != "" && moment(salesBehavior.value).format(dateFormat) !== moment(propertyValue).format(dateFormat)) {

                    self.payload = {
                        'inlineColumnType': salesBehaviorId,
                        'inlineColumnValue': propertyValue,
                        'project': project,
                        'salesBehaviorId': salesBehaviorId,
                        'isSalesBehavior': true,
                    }

                    self.sendPostRequest();
                }
            });
        },

        adjustTextColor(project,status_id) {
            let element, bgColor, broderColor;
            element = 'sales_statuses_code_'+project.id;
            if (status_id === null || status_id === ''){
                return;
            }
            let saleStatus = this.mapSaleStatus(status_id);
            bgColor = this.increaseBrightness(saleStatus.color, 70);
            broderColor = this.darkColor(saleStatus.color, -20);

            $('.'+element).css("background-color",bgColor);
            $('.'+element).css("border",broderColor+' 1px solid');

        },
        mapSaleStatus(status_id){
            return _.find(this.selects.sales_status, function(obj) { return obj.id == status_id });
        },

        increaseBrightness(hex, percent){
            hex = hex.replace(/^\s*#|\s*$/g, '');

            if(hex.length == 3){
                hex = hex.replace(/(.)/g, '$1$1');
            }

            var r = parseInt(hex.substr(0, 2), 16),
                g = parseInt(hex.substr(2, 2), 16),
                b = parseInt(hex.substr(4, 2), 16);

            return '#' +
                ((0|(1<<8) + r + (256 - r) * percent / 100).toString(16)).substr(1) +
                ((0|(1<<8) + g + (256 - g) * percent / 100).toString(16)).substr(1) +
                ((0|(1<<8) + b + (256 - b) * percent / 100).toString(16)).substr(1);
        },

        darkColor(color, percent) {

            var R = parseInt(color.substring(1,3),16);
            var G = parseInt(color.substring(3,5),16);
            var B = parseInt(color.substring(5,7),16);

            R = parseInt(R * (100 + percent) / 100);
            G = parseInt(G * (100 + percent) / 100);
            B = parseInt(B * (100 + percent) / 100);

            R = (R<255)?R:255;
            G = (G<255)?G:255;
            B = (B<255)?B:255;

            var RR = ((R.toString(16).length==1)?"0"+R.toString(16):R.toString(16));
            var GG = ((G.toString(16).length==1)?"0"+G.toString(16):G.toString(16));
            var BB = ((B.toString(16).length==1)?"0"+B.toString(16):B.toString(16));

            return "#"+RR+GG+BB;
        },
        changeItemPerPage(){
            this.$nextTick(() => {
                this.fetchProjects(this.current_search_pattern, 1);
                this.updateItemPerPage();
            });
        },
        updateItemPerPage(){
            axios.post(route('user.update-item-per-page'), {item:'project', itemPerPage:this.itemPerPage});
        },
        addComment() {
            $("#projectCommentModal").modal("show");
        },
        addMention(replaced) {
            if (_.find(this.projectCommentForm.mentioned_users, o => o === replaced.id)) {
                return;
            }
            this.projectCommentForm.mentioned_users.push(replaced.id);
        },

        filterUsers(mentionText, cb) {
            const users = _.filter(this.selects.users, (user) => user.name.indexOf(mentionText) !== -1);
            cb(users.slice(0, 5));
        },
        projectCommentSaved() {
            let self = this;
            self.projectCommentForm.saving = true;

            const salesStatus = this.checkIfProjectNeedsCommentBySalesStatus();

            if (salesStatus) {
                self.projectCommentForm.sales_status_id = salesStatus.id;
            }

            self.projectCommentForm.post(route('api.project-comment.store', {project: self.projectCommentForm.project_id})).then((res) => {
                this.projectCommentForm.saving = false;
                this.checkCommentStatus = self.projectCommentForm.project_id;
                $("#projectCommentModal").modal("hide");
                this.sendPostRequest();
            });


        },
        checkIfProjectNeedsCommentBySalesStatus() {
            const oldStatus = _.find(this.selects.sales_status, {id: this.emptyContractAmountProject.sales_status_id});
            const newStatus = _.find(this.selects.sales_status, {id: this.projectCommentForm.sales_status.id});

            if ((this.noStatusToNewStatus(oldStatus, newStatus) || (this.bothStatusesUndefined(oldStatus, newStatus) && !this.isSameStatus(oldStatus, newStatus))) && newStatus.comment) {
                return newStatus;
            }
            return null;
        },
        noStatusToNewStatus(oldStatus, newStatus) {
            return typeof oldStatus === "undefined" && typeof newStatus !== "undefined";
        },

        bothStatusesUndefined(oldStatus, newStatus) {
            return typeof oldStatus !== "undefined" && typeof newStatus !== "undefined";
        },

        isSameStatus(oldStatus, newStatus) {
            return oldStatus !== undefined && newStatus !== undefined && oldStatus.id === newStatus.id;
        },

        closeProjectCommentModal() {
            let self = this;
            $("#projectCommentModal").modal("hide");
            self.projectCommentForm.reset();
            this.sendPostRequest();
        },
        getWidth() {
            let self = this;
            self.fetchWidth();
            $(window).click((event)=>{
                let widthcls = $(event.target).attr('class');
                let words = '';
                let cls1 = '';
                if (widthcls.includes('column-resize')) {
                    words = widthcls.split(' ');
                    cls1 = words[1];
                    if (self.width && Object.keys(self.width).length > 0){
                        self.width[cls1] = $('.'+cls1).width()
                        self.saveWidth(self.width)
                    }
                    else {
                        let  columnwidth = {}
                        columnwidth[cls1] = $('.'+cls1).width()
                        self.saveWidth(columnwidth)
                    }
                }
            });
        },
        saveWidth(width){
            axios.post('/set-column-size',{ sizewidth: width }).then(res=>{
            })
        },
        fetchWidth(){
            let self = this;
            axios.get('/get-column-size').then(res=>{
                self.width = res.data.widthsize
                if ( self.width && Object.keys(self.width).length > 0){
                    for (let i = 0; i < Object.keys(self.width).length; i++){
                        $('.'+Object.keys(self.width)[i].toString()).width(Object.values(self.width)[i].toString() +'px')
                    }
                }
            })
        }
    }
}
</script>

<style>
.pagination > li > a {
    color: #4dc0b5;
}

.pagination > li > a:hover {
    background-color: #4dc0b5 !important;
    color: white;
}

.bg-qualified {
    background-color: #00ff8f;
}

li.page-item.active > a {
    background-color: #4dc0b5 !important;
    border-color: #4dc0b5 !important;
}

a.page-link:focus {
    box-shadow: none;
}

.project-listing-dropdown-button {
    border-color: #14b1af !important;
    color: #14b1af !important;
}

.overflowStyle {
    overflow: auto;
}

.custom-height-class {
    height: 150px;
}

.project-listing-dropdown-button:hover,
.project-listing-dropdown-button:active,
.project-listing-dropdown-button:focus,
.project-listing-dropdown-button:visited,
.project-listing-dropdown-button:focus-visible,
.project-listing-dropdown-button:focus-within,
.project-listing-dropdown-button:target,
.project-listing-dropdown-button .show > .btn-outline-success.dropdown-toggle {
    border-color: #14b1af !important;
    color: #ffffff !important;
    background-color: #14b1af !important;
    box-shadow: none !important;
}

.add-view-button {
    font-size: 13px;
    color: #14b1af;
    margin: 8px;
    outline: unset;
}

.bulk-update-button {
    font-size: 15px;
    font-weight: normal;
    color: #14b1af;
}

tr:hover > td > span > input,
tr:hover > td > div > span > select,
tr:hover > td > div > span > input,
tr:hover > td > span > div > div > input,
tr:hover > td > div > span > div > div > input {
    background-color: white !important;
}

tr > td > span > div.required-field-missing > input,
tr:hover > td > span > div.required-field-missing > input {
    background-color: #F78580 !important;
}

.required-field-missing {
    background: #F78580;
}

#project_index .fix-name-content {
    white-space: nowrap;
    text-overflow: ellipsis;
    width: 10vw !important;
    display: block;
}

.inline_update_loading_class {
    position: absolute;
    top: 50%;
    left: 50%;
}

#project_index {
    border-collapse: collapse;
    border-spacing: 0px;
    overflow: scroll;
}

#project_index th.column-header-resize {
    padding: 0;
    margin: 0px;
}

#project_index th.column-header-resize div.column-resize {
    resize: horizontal;
    overflow: auto;
    min-width: 90%;
    margin: 0px;
    padding: 0px;
    display: block;
    border: 0;
}

#project_index td.td-text-overflow {
    overflow: hidden;
}

.pin-black {
    font-size: 16px !important;
}

.pin-red {
    font-size: 16px !important;
    color: red !important;;
}

.pin-project-highlighted {
    background-color: #fff5eb;
}
.custom-checkbox.check_current_checkbox{
    margin-left: 7px !important;
}
.custom-checkbox.check_current_checkbox2{
    margin-left: 16px !important;
}

.custom-control-input:checked ~ .custom-control-label::before {
    color: #fff !important;
    background-color: #0068f8 !important;
    border-color: #0068f8 !important;
}
@media only screen
and (min-device-width: 768px)
and (max-device-width: 1024px)
and (-webkit-min-device-pixel-ratio: 1) {
    td > span {
        white-space: nowrap;
        width: auto !important;
        display: block;
    }

    select {
        white-space: nowrap;
        width: auto !important;
        display: block;
    }

    #project_index .fix-name-content {
        white-space: nowrap;
        width: auto !important;
        display: block;
    }
}

@media only screen
and (min-device-width: 768px)
and (max-device-width: 1024px)
and (orientation: portrait)
and (-webkit-min-device-pixel-ratio: 1) {
    td > span {
        white-space: nowrap;
        width: auto !important;
        display: block;
    }

    select {
        white-space: nowrap;
        width: auto !important;
        display: block;
    }

    #project_index .fix-name-content {
        white-space: nowrap;
        width: auto !important;
        display: block;
    }
}

.tooltip-inner {
    width: 100% !important;
    max-width: 700px;
    height: auto;
}
</style>
